import React from "react";
import AdminSideBar from "./AdminSideBar";
import useWindowSize from "../hooks/WindowResizer";
import Header from "./Header";

const AdminLayout = ({ children }) => {
  const isMobileView = useWindowSize();
  return (
    <div className="layout-root">
      {!isMobileView && <AdminSideBar />}
      <Header />
      <main>{children}</main>

      <style>
        {`.makeStyles-App_root-3 {
        background: #F9f9f9 !important;
      }
      `}
      </style>
    </div>
  );
};

export default AdminLayout;